import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './utils/sentry';

// Iniciar Sentry antes de renderizar nada para capturar errores del arranque.
// Si REACT_APP_SENTRY_DSN no está definida, queda inerte.
initSentry();

// ════════════════════════════════════════════════════════════════════
// Cache-busting agresivo: en APK (Capacitor), el WebView puede servir
// código viejo cacheado aunque reinstales. Desregistramos cualquier
// service worker y limpiamos todas las cachés al arrancar.
// ════════════════════════════════════════════════════════════════════
(async () => {
    try {
        const isCapacitor = typeof window !== 'undefined' &&
            (window.location.protocol === 'capacitor:' ||
             (window.location.protocol === 'https:' && window.location.hostname === 'localhost'));

        if (isCapacitor) {
            // Desregistrar todos los service workers
            if ('serviceWorker' in navigator) {
                const regs = await navigator.serviceWorker.getRegistrations();
                for (const r of regs) {
                    try { await r.unregister(); } catch {}
                }
            }
            // Limpiar todas las cachés
            if ('caches' in window) {
                const keys = await caches.keys();
                for (const k of keys) {
                    try { await caches.delete(k); } catch {}
                }
            }
        }
    } catch (e) {
        console.warn('[cache-cleanup]', e?.message);
    }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
